export default {"src":"/_next/static/media/heart.a795e81a.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};